import type { FeatureFlagStatusModel } from '@/models';
import Api from './baseService';

async function getCurrentFeatureFlags(): Promise<FeatureFlagStatusModel[]> {
  const response = await Api.get('feature-flags/current');
  return response.data as FeatureFlagStatusModel[];
}

export {
  getCurrentFeatureFlags,
}
